import { z } from 'zod';

const specialChars = new RegExp(/[!$#%&*]/);
const mixedCase = new RegExp(/(?=.*[a-z])(?=.*[A-Z])/);
const alphaNumeric = new RegExp(/(?=.*[a-zA-Z])(?=.*\d)/);

export const updatePasswordIssueMessages = new Map([
    ['tooShort', 'Must be at least 8 characters long'],
    [
        'needsSpecialChars',
        'Must contain one of these special characters: ! $ # % & *',
    ],
    [
        'needsMixedCase',
        'Must contain at least one uppercase and one lowercase letter',
    ],
    ['needsAlphaNumeric', 'Must contain both letters and numbers'],
]);

export const updatePasswordSchema = z.object({
    password: z
        .string()
        .min(8, {
            message: updatePasswordIssueMessages.get('tooShort'),
        })
        .regex(specialChars, {
            message: updatePasswordIssueMessages.get('needsSpecialChars'),
        })
        .regex(mixedCase, {
            message: updatePasswordIssueMessages.get('needsMixedCase'),
        })
        .regex(alphaNumeric, {
            message: updatePasswordIssueMessages.get('needsAlphaNumeric'),
        }),
});
